import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, MapPin, Trophy, Globe2, GraduationCap } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CourseResultCard from "../components/CourseResultCard";
import { getUniversity } from "../data/universities";

export default function UniversityDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const uni = getUniversity(id);

  useEffect(() => { window.scrollTo(0, 0); }, [id]);

  if (!uni) {
    return (
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        <div className="max-w-[760px] mx-auto px-5 py-24 text-center flex-1">
          <h1 className="font-head text-2xl font-bold text-[#16244F]">University not found</h1>
          <button onClick={() => navigate("/universities")} className="mt-5 text-[#F58220] font-head font-semibold">Back to Explorer</button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f6f8fc] flex flex-col">
      <Header />
      <main className="flex-1">
        <section className="relative h-[300px] md:h-[380px] overflow-hidden">
          <img src={uni.image} alt={uni.name} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#16244F] via-[#16244F]/60 to-transparent" />
          <div className="absolute inset-0 max-w-[1240px] mx-auto px-5 flex flex-col justify-end pb-8">
            <button onClick={() => navigate("/universities")} className="inline-flex items-center gap-1.5 text-white/80 hover:text-white font-head text-sm mb-4 w-fit">
              <ArrowLeft size={16} /> University Explorer
            </button>
            <h1 className="font-head text-3xl md:text-5xl font-bold text-white">{uni.name}</h1>
            <div className="flex flex-wrap items-center gap-4 mt-3 text-white/85">
              <span className="inline-flex items-center gap-1.5"><MapPin size={16} className="text-[#F9B57C]" /> {uni.city}, {uni.country}</span>
              <span className="inline-flex items-center gap-1.5"><Trophy size={16} className="text-[#F9B57C]" /> QS #{uni.qs}</span>
              <span className="inline-flex items-center gap-1.5"><GraduationCap size={16} className="text-[#F9B57C]" /> {uni.programs.length} programmes</span>
            </div>
          </div>
        </section>

        <section className="max-w-[1240px] mx-auto px-5 py-10 md:py-14">
          <div className="bg-white rounded-2xl cc-shadow-card p-7 md:p-8 mb-10">
            <h2 className="font-head text-xl font-bold text-[#16244F] flex items-center gap-2"><Globe2 size={20} className="text-[#2b8cf0]" /> About</h2>
            <p className="text-[#5a6274] mt-3 leading-relaxed">{uni.about}</p>
          </div>

          <h2 className="font-head text-2xl font-bold text-[#16244F] mb-6">Programmes Offered</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
            {uni.programs.map((c) => <CourseResultCard key={c.id} c={c} showFit={false} />)}
          </div>

          <div className="mt-10 rounded-2xl bg-[#eaf3ff] p-7 text-center">
            <h3 className="font-head text-xl font-bold text-[#16244F]">Interested in {uni.name}?</h3>
            <p className="text-[#5a6274] mt-2">Book a free session and we'll guide your application end-to-end.</p>
            <button onClick={() => navigate("/", { state: { scrollTo: "contact" } })} className="mt-5 inline-flex items-center gap-2 bg-[#F58220] hover:bg-[#e0730f] text-white font-head font-semibold px-6 py-3 rounded-lg transition-colors">Talk to a Counsellor</button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
